module.exports = __webpack_public_path__ + "static/media/404.dc7c16bb.png";